import { Observable, Subject } from 'rxjs';
import { finalize, takeUntil } from 'rxjs';

export class CsSocket<T> {
  private subject = new Subject<T>();

  private listener = (data: T) => {
    this.subject.next(data);
  };

  constructor(
    private event: string,
    private socket: SocketIOClient.Socket,
    private $disconnected: Observable<void>
  ) {
    socket.on(this.event, this.listener);
  }

  public get onPush(): Observable<T> {
    return this.subject.pipe(
      takeUntil(this.$disconnected),
      finalize(() => this.close())
    );
  }

  public close(): void {
    this.socket.removeListener(this.event, this.listener);
    this.subject.complete();
  }
}
